// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (min-width:1200px){.customPadding{padding-top:25%}}@media (min-width:992px) and (max-width:1199px){.customPadding{padding-top:20%}}@media (min-width:768px) and (max-width:991px){.customPadding{padding-top:15%}}@media (max-width:767px){.customPadding{padding-top:3%}}@media (max-width:480px){.customPadding{padding-top:2%}}", ""]);
// Exports
module.exports = exports;
